import { Input, Select } from 'antd';
import { TagOutlined } from '@ant-design/icons';
import MobileFilterPanel from '../../components/filters/MobileFilterPanel';
import DateRangePair from '../../components/filters/DateRangePair';
import { useActiveFilters } from '../../components/filters/useActiveFilters';
import TagFilter from '../article-list/TagFilter';
import type { MediaFilterBarProps } from './MediaFilterBar';

/** 媒體庫篩選（手機）：關鍵字常駐，標籤／分類／刊出日收在「篩選」面板。 */
export default function MobileMediaFilterBar({ categories, onChange }: MediaFilterBarProps) {
  const { count, mark } = useActiveFilters();
  return (
    <MobileFilterPanel
      activeCount={count}
      search={
        <Input.Search
          placeholder="關鍵字（檔名、圖說、文章標題）"
          allowClear
          onSearch={(v) => onChange({ q: v.trim() || undefined })}
        />
      }
    >
      <TagFilter
        full
        onChange={(tagId) => {
          mark('tag', !!tagId);
          onChange({ tagId });
        }}
      />
      <Select
        placeholder="分類"
        allowClear
        suffixIcon={<TagOutlined />}
        className="w-full"
        onChange={(categoryId?: string) => {
          mark('category', !!categoryId);
          onChange({ categoryId });
        }}
        options={categories}
      />
      <DateRangePair
        placeholder={['刊出日（起）', '刊出日（迄）']}
        onChange={(dateFrom, dateTo) => {
          mark('date', !!(dateFrom || dateTo));
          onChange({ dateFrom, dateTo });
        }}
      />
    </MobileFilterPanel>
  );
}
